module.exports = __webpack_public_path__ + "static/1-10d8a2036b2c4bc9d39affa9df6e6520.jpeg";